import React from "react";
import { Footer, HeaderWithLogin } from "@/modules/login/ui";
import { observer } from "mobx-react-lite";
import { loginStore } from "@/modules/login/store";
import loginImage from "@/assets/images/login/login_bg.png";
import productImage from "@/assets/images/login/login_product.png";
import aigcAssistant from "@/assets/images/login/aigc_assistant.png";
import GalleryImgA from "@/assets/images/login/creator-gallery-top.jpeg";
import GalleryImgB from "@/assets/images/login/creator-gallery-bottom.jpeg";
import { useResponsive } from "@/utils/style";
import LogoImg from "@/assets/images/login/bitmap-logo.png";
import TopBannerImg from "@/assets/images/login/top-banner.png";
import SubTitleImg from "@/assets/images/login/sub-title.png";
import styles from "./style.module.scss";
import { useHistory } from "react-router";
import { chakra } from "@chakra-ui/react";
import getScrollBarProps from "@/styles/scrollBarProps";
import { Link } from "react-router-dom";

const HeaderContentHeigh = "64px";
const ShowBaiduDocument = true;
const scrollProps = getScrollBarProps({ scrollBarWidth: 0 });
function Login(props: any) {
  const calcPx = useResponsive();
  const history = useHistory();
  function openLogin() {
    if (loginStore.hasUserInfo) {
      if (loginStore.hasAIGCPermission) {
        history.push("/creator");
      } else {
        history.push("/noPermission");
      }
    } else {
      loginStore.openLoginDialog({}, () => {
        history.push("/creator");
      });
    }
  }
  return (
    <div className={styles["login-page-wrapper"]}>
      {/* <img src={TopBannerImg} alt="" className={styles["top-banner-img"]} /> */}
      <HeaderWithLogin renderBanner renderBusinessLink />
      <chakra.div w="100%" h="100vh" {...scrollProps}>
        <div className={styles["content-wrapper"]} style={{ paddingTop: HeaderContentHeigh }}>
          <img
            className={styles["sub-title-img"]}
            style={{ marginTop: calcPx(120), width: calcPx(600) }}
            src={SubTitleImg}
            alt="画宇宙 AI 创作平台"
          />
          <div className={styles["title-B"]} style={{ fontSize: calcPx(100) }}>
            面向专业场景的 AIGC 平台
          </div>

          <Link
            className={styles["start-btn"]}
            to="/business"
            style={{
              marginTop: calcPx(100),
              width: calcPx(208),
              height: calcPx(64),
              lineHeight: calcPx(64),
              fontSize: calcPx(24),
            }}
          >
            企业咨询
          </Link>
          <div
            className={styles["img-title-A"]}
            style={{ marginTop: calcPx(81), fontSize: calcPx(24) }}
          >
            Nolibox 专注于为品牌、工业设计、电商、服装等行业提供专业的 AIGC 图像与设计解决方案，
            <br />
            已成功服务中国电信、百度、阿里1688、海尔等众多企业客户。
          </div>
          <div className={styles["img-A-wrapper"]}>
            <img src={GalleryImgA} alt="画宇宙用户作品，AI 做图结果、AI 绘图效果展示" />
          </div>
          <div className={styles["img-title-B"]} style={{ fontSize: calcPx(32) }}>
            融汇各类 AI 能力，打造 AIGC 生产力平台
          </div>
          <div className={styles["img-B-wrapper"]}>
            <img
              src={GalleryImgB}
              alt="画宇宙：无限画板 + 无限想象力；画宇宙支持文本生成图像、提示词生成、内容去除、循环可密铺纹样生成、局部消除（修补图像瑕疵）、涂鸦智能成稿、相似图生成（图像族管理）；画宇宙拥有多源生成模型引擎，取之于开源、用之于开源；画宇宙支持个人本地部署，生成不排队；来画宇宙，加入来自全球创作者的内容社群"
            />
          </div>
          <Footer />
        </div>
      </chakra.div>
    </div>
  );
}

export default observer(Login);
